import { css } from "lit";

export const style = css`
	* {
		box-sizing: border-box;
	}
	
	:host {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 100%;
		position: relative;
	}
	
	og-markdown-editor {
		height: 100%;
		padding: 5px;
	}
	
	#attachments {
		font-size: 12px;
		display: flex;
		flex-direction: row-reverse;
		flex-wrap: wrap;
		align-items: center;
		gap: 5px;
	}

	.controls {
		padding: 5px 10px;
		flex: 0 0 auto;
		display: flex;
		flex-direction: row;
		justify-content: flex-end;
		background: var(--og-background-color);
	}

	.controls-box {
		flex: 1;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-end;
		gap: 10px;
		padding: 4px 8px;
		border: 1px solid var(--og-border-color);
		border-radius: var(--og-base-radius);
		background: var(--og-background-color-2);
	}

	/* the dropdowns may shrink (they collapse into one menu below COMPACT_CONTROLS_WIDTH), the buttons never do */
	.ticket-prop {
		flex: 0 1 auto;
		min-width: 0;
	}

	.ticket-prop-compact {
		flex: 0 0 36px;
	}

	.btn-send, .btn-attach {
		flex: 0 0 auto;
	}

	.btn-send {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 36px;
		height: 36px;
		border-radius: 50%;
		background-color: var(--og-accent-color);
		color: white;
		font-size: 18px;
		font-weight: bold;
		cursor: pointer;
	}

	.btn-attach {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 36px;
		height: 36px;
		border-radius: 50%;
		font-size: 18px;
		color: var(--og-text-color);
		cursor: pointer;
	}

	.btn-attach:hover {
		background-color: var(--og-colortype-gray-background-color);
	}
`;
